export default "__VITE_ASSET__CqHIBc2J__"